module.exports = __webpack_public_path__ + "static/assets/dde8aa58f32f9d0e50af951995bdca7f.png";